import { initFacetOverviewFilters } from '~/js/components/facet-overview-filters';

initFacetOverviewFilters( {
	sectionSelector: '.exp-events-facet-overview',
	filterTargets: [
		'industry',
		'topic',
		'event_location_city',
		'events_past',
	],
	urlPanelMappings: [
		{ param: '?_connected_event_industries', target: 'industry' },
		{ param: '?_connected_event_topics', target: 'topic' },
		{ param: '?_events_location_filter', target: 'event_location_city' },
		{ param: '?_events_past_filter', target: 'events_past' },
	],
} );
